/**
 * Section 9: Marketability Assessment
 */

import { useCallback } from 'preact/hooks';
import { useForm } from '@ox/visits-ui/context/FormContext';
import { Input, Select, Textarea } from '@ox/visits-ui/components/shared/FormComponents';

export function Section9MarketabilityAssessment() {
  const { formData, updateField } = useForm();

  const handleProsChange = useCallback(
    (value: string) => updateField('pros', value),
    [updateField],
  );
  const handleConsChange = useCallback(
    (value: string) => updateField('cons', value),
    [updateField],
  );
  const handlePriceSuggestionChange = useCallback(
    (value: string) => updateField('price_suggestion', value),
    [updateField],
  );
  const handleSuggestedPriceChange = useCallback(
    (value: string) => updateField('suggested_price', value),
    [updateField],
  );

  return (
    <div className="form-section">
      <h2>Marketability Assessment</h2>

      <Textarea
        label="What are some pros of this property that may influence buyer perception or pricing?"
        name="pros"
        value={formData.pros || ''}
        onChange={handleProsChange}
        placeholder="e.g., Pros – recently updated kitchen, great curb appeal. Low inventory in area"
        rows={5}
      />

      <Textarea
        label="What are some cons of this property that may influence buyer perception or pricing?"
        name="cons"
        value={formData.cons || ''}
        onChange={handleConsChange}
        placeholder="e.g., Cons – strong pet odor, outdated bathrooms. High market saturation"
        rows={5}
      />

      <Select
        label="Based on what you saw during your visit, does the current list price seem appropriate for this home?"
        name="price_suggestion"
        value={formData.price_suggestion || ''}
        onChange={handlePriceSuggestionChange}
        options={[
          { label: 'Select...', value: '', disabled: true },
          { label: 'Yes – Price aligns with current condition and market', value: 'Yes – Price aligns with current condition and market' },
          { label: 'No – Price is slightly high for condition or buyer expectations', value: 'No – Price is slightly high for condition or buyer expectations' },
          { label: 'No – Price is EXTREMELY high for condition or buyer expectations', value: 'No – Price is EXTREMELY high for condition or buyer expectations' },
        ]}
        required
      />
      {formData.price_suggestion && formData.price_suggestion.startsWith('No') && (
        <Input
          label="what price would you suggest?"
          name="suggested_price"
          value={formData.suggested_price || ''}
          onChange={handleSuggestedPriceChange}
          placeholder="Please specify"
          type="number"
          min={0}
          required
        />
      )}
    </div>
  );
}
